import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  Stack,
  Chip,
  Box,
} from '@mui/material';
import {
  Person as PersonIcon,
  Email as EmailIcon,
  AdminPanelSettings as AdminIcon,
} from '@mui/icons-material';
import { useAuth } from '../../auth/context/AuthContext';

const SettingsProfileTab = () => {
  const { user } = useAuth();
  const displayName = user?.username || user?.email || 'Διαχειριστής';
  const displayEmail = user?.email || user?.username || '—';

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <Card sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
          <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
            <Stack alignItems="center" spacing={2} sx={{ py: 2 }}>
              <Avatar
                sx={{
                  width: { xs: 72, sm: 96 },
                  height: { xs: 72, sm: 96 },
                  bgcolor: 'primary.main',
                  fontSize: { xs: '2rem', sm: '2.5rem' },
                }}
              >
                <PersonIcon fontSize="inherit" />
              </Avatar>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {displayName}
                </Typography>
                <Chip
                  icon={<AdminIcon />}
                  label="Διαχειριστής"
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ mt: 1 }}
                />
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={7}>
        <Card sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, height: '100%' }}>
          <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Στοιχεία λογαριασμού
            </Typography>
            <Stack spacing={2}>
              <Box>
                <Typography variant="caption" color="text.secondary">
                  Όνομα χρήστη
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {displayName}
                </Typography>
              </Box>
              <Box>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
                  <EmailIcon fontSize="small" color="action" />
                  <Typography variant="caption" color="text.secondary">
                    Email
                  </Typography>
                </Stack>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {displayEmail}
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ pt: 1 }}>
                Η επεξεργασία προφίλ και αλλαγή κωδικού θα προστεθούν σε επόμενο βήμα.
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SettingsProfileTab;
